<template>
	<div class="new-schedule">
		<el-form :inline="true">
			<el-form-item>
				<el-select
					v-model="selectedPatient"
					placeholder="Select patient"
					style="width:200px"
					size="small"
					filterable>
					<el-option v-for="patient in population"
						:key="patient.id"
						:label="patient.name"
						:value="patient.id">
						<span style="float: left;min-width:200px;">{{ patient.name }}</span>
      					<span style="float: right; color: #8492a6; font-size: 13px">{{ patient.email }}</span>
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="selectedPatient">
				<el-select
					v-model="selectedEvent"
					placeholder="Select event"
					style="width:200px"
					size="small"
					filterable>
					<el-option v-for="event in orderedEvents"
						:key="event.id"
						:label="event.name"
						:value="event.id">
					</el-option>
				</el-select>
			</el-form-item>
			<el-form-item v-if="selectedPatient">
				<el-date-picker
					v-model="selectedTime"
					type="date"
					format="MM/dd/yyyy"
					placeholder="Select date of the event"
					style="width:220px"
					size="small"
					range-separator="/">
				</el-date-picker>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" size="small"
					:disabled="! valid || scheduling"
					@click="create">
					<strong>Create Event</strong>
				</el-button>
			</el-form-item>
		</el-form>

		<el-dialog title="Past Messages"
			:append-to-body="true"
			:visible.sync="selectPastMessages">
			<p style="margin-top:-30px;">Select the messages that should be sent immediately to this patient.</p>
			<br>
			<PastMessage
				:time="selectedTime"
				:message="pastMessages"
				:event="selectedEvent"
				@confirm="createAndSend"
				@cancel="cancelCreate">
			</PastMessage>
		</el-dialog>
	</div>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import format from '@/module/util/format'

import PastMessage from './message/Past'

export default {
	name: 'population-schedule-card-form',

	props: {
		population: {
			type: Array,
			required: true
		}
	},

	data() {
		return {
			selectedPatient: null,
			selectedEvent: null,
			selectedTime: null,

			// Whether to show the past messages dialog, and the selected past messages
			selectPastMessages: false,
			pastMessage: {}
		}
	},

	mounted() {
	},

	watch: {
		// TEMP: there should be an API request that loads all event content
		providerEvents() {
			// If there is any missing provider event content, load all provider events
			let missingEvents = this.providerEvents.filter((eventId) => (this.getContent('event', eventId) == null))
			if (missingEvents.length > 0) {
				console.log('loading events')
				this.loadContent({
					type: 'event',
					id: missingEvents.join(',')
				})
			}
		}
	},

	methods: {
		...format,
		...mapActions('provider', [
			'createPatientSchedule'
		]),
		...mapActions('content', [
			'loadContent'
		]),
		/**
		 * @func create
		 * @desc Creates a new schedule for the patient.
		 */
		create() {
			var time = new Date(this.selectedTime).getTime()
			time -= new Date(this.selectedTime).getTimezoneOffset() * 60000

			if (this.pastMessages.length > 0) {
				this.selectPastMessages = true
			}
			else this.createPatientSchedule({
				patient: this.patient.id,
				event: this.selectedEvent,
				time
			})
			.then(() => {
				this.reset()
			})
		},
		/**
		 * @func create
		 * @desc Creates a new schedule for the patient and send the specified past messages.
		 */
		createAndSend(send) {
			this.selectPastMessages = false

			var time = new Date(this.selectedTime).getTime()
			time += new Date(this.selectedTime).getTimezoneOffset() * 60000

			this.createPatientSchedule({
				patient: this.patient.id,
				event: this.selectedEvent,
				send,
				time
			})
			.then(() => {
				this.reset()
			})
		},

		cancelCreate() {
			this.selectPastMessages = false
		},

		reset() {
			this.event = null
			this.time = null
		}
	},

	computed: {
		...mapGetters('provider', [
			'getPatient',
			'getProvider',
			'getPatientSchedulingState'
		]),
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		providerEvents() {
			if (this.getProvider)
				return [].concat.apply([], this.getProvider.profile.map((profile) => (profile.event || [])))
			return []
		},
		patient() {
			return this.getPatient(this.selectedPatient)
		},
		patientEventIds() {
			if (this.patient)
				return [].concat.apply([], this.patient.profile.map((profile) =>
						(this.getContentKey('profile', profile, 'event') || [])))
		},
		patientEvents() {
			if (this.patientEventIds)
				return this.patientEventIds
					.map((id) => this.getContent('event', id))
					.filter((e) => e != null)
		},
		orderedEvents() {
			if (this.patientEvents)
				return this.patientEvents.slice().sort((a, b) => {
					return a.name.toLowerCase().localeCompare(b.name.toLowerCase())
				})
		},
		pastMessages() {
			if (! this.selectedEvent || ! this.selectedTime) return null

			var now = Date.now()
			var time = new Date(this.selectedTime).getTime()

			var event = this.patientEvents.find((e) => e.id == this.selectedEvent)
			if (event && Array.isArray(event.message))
				return event.message.filter((message) => (time + message.delay < now))
			return []
		},
		scheduling() {
			if (this.patient)
				return this.getPatientSchedulingState(this.patient.id)
		},
		valid() {
			return this.selectedEvent != null && this.selectedTime != null
		}
	},

	components: {
		PastMessage
	}
}
</script>

<style lang="scss" scoped>
.new-schedule {
	padding: 10px 10px 15px 10px;
	height: 60px;
	border-bottom: solid 1px #f0f0f0;

	.el-button {
		font-size: 15px;

	}
}
</style>
